import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ENVIRONMENT, SharedEnv } from 'shared-ui/di/environment';

@Pipe({
  name: 'fileUrl',
  standalone: false,
})
export class FileUrlPipe implements PipeTransform {
  private env = inject<SharedEnv>(ENVIRONMENT);
  private sanitizer = inject(DomSanitizer);

  transform(fileName: string, namespace: string, entityId?: string) {
    const url = FileUrlPipe.getUrl(this.env, fileName, namespace, entityId);
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  static getUrl(env: SharedEnv, fileName: string, namespace: string, entityId?: string) {
    return `${env.filesUrl}/${namespace}${entityId ? `/${entityId}` : ''}/${fileName}`;
  }
}

export function fileUrlFactory() {
  const env = inject<SharedEnv>(ENVIRONMENT);
  return (fileName: string, namespace: string, entityId?: string) =>
    FileUrlPipe.getUrl(env, fileName, namespace, entityId);
}
